import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect, Icon, InputGroup, NonIdealState, Radio, RadioGroup, Tab, Tabs, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, IImportErro, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { ImportStore } from "../../stores/import/ImportStore";
import ImportNFESPage from "./ImportNFES";
import ImportCTEPage from "./ImportCTE";
import ImportNFCEPage from "./ImportNFCE";
import { toast } from "react-toastify";
import ImportNFSEPage from "./ImportNFSE";
import InfiniteScroll from 'react-infinite-scroll-component';
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj } from "../../utils";
import { DateRangePicker } from "../utils/DateRangePicker";
import { PagerResultados } from "../utils/PagerResultados";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
require("../../assets/css/components/ImportPage.css");

interface ImportPageProps {
}

interface ImportPageState {
}

@observer
export default class ImportPage extends React.Component<ImportPageProps, ImportPageState> {

  obs = observable({
    selectedTab: "nfes" as string,
    detalhes_import: false as boolean,
    detalheTab: "erros" as "erros" | "avisos",
    import_erros: [] as IImportErro[],
    tarefas_page: 1 as number,
    import_id: "" as string,
    erros_page: 1 as number,
    avisos_page: 1 as number,
    selectEmpresa: newEmpresa() as IEmpresa,
    selectedPeriod: [] as any,
    date1: "" as string,
    date2: "" as string,
    status: 5 as number
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Importação de XMLs");
    ImportStore.handleConsultaTodas(this.obs.tarefas_page, this.obs.selectEmpresa.cnpj, this.obs.status, this.obs.date1, this.obs.date2);
  }

  handleDateSolicitacaoChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.obs.date1 = moment(array[0]).format("YYYY-MM-DD")
    this.obs.date2 = moment(array[1]).format("YYYY-MM-DD")

    if (this.obs.date1 == "" ||  this.obs.date1 == "Data inválida") {
      this.obs.date1 = null
    }

    if (this.obs.date2 == "" || this.obs.date2 == "Data inválida") {
      this.obs.date2 = null
    }

    this.obs.selectedPeriod = val;

    if (this.obs.date1 != "" && this.obs.date2 != "" && this.obs.date1 != "Data inválida" && this.obs.date2 != "Data inválida") {
      this.handleBuscaImportacao(val)
    }

  };

  handleBuscaTarefasPaged = async (page: number) => {
    this.obs.tarefas_page = page
    ImportStore.handleConsultaTodas(page, this.obs.selectEmpresa.cnpj, this.obs.status, this.obs.date1, this.obs.date2);
  };

  handleCloseDetalhes() {
    this.obs.detalheTab = "erros"
    this.obs.detalhes_import = false
  }

  onCloseImportarXmls() {
    ImportStore.obs.importarXmls = false
    ImportStore.obs.descricao_import = ""
    ImportStore.obs.selectedEmpresaImport = newEmpresa()
  }

  handleBuscaImportacao = async (value: any) => {
    this.obs.tarefas_page = 1
    await ImportStore.handleConsultaTodas(this.obs.tarefas_page, this.obs.selectEmpresa.cnpj, this.obs.status, this.obs.date1, this.obs.date2);
  };

  handleCleanFilter() {
    this.obs.status = 5
    this.obs.tarefas_page = 1
    this.obs.date1 = ""
    this.obs.date2 = ""
    this.obs.selectedPeriod = [];

    this.obs.selectEmpresa = newEmpresa()
    ImportStore.handleConsultaTodas(1, "", 5, "", "");

  }

  render() {

    const handleViewDetalhes = async (row) => {

      await ImportStore.summary_import(row.importacao_id, row.tipo, row.modelo);

      if (!ImportStore.obs.isValida) {
        let importId = ImportStore.obs.import_summary.import._id
        this.obs.import_id = importId
        this.obs.erros_page = 1
        this.obs.avisos_page = 1
        ImportStore.obs.avisos_import = []
        ImportStore.obs.erros_import = []

        await ImportStore.busca_erros(this.obs.erros_page, 15, importId);
        await ImportStore.busca_avisos(this.obs.avisos_page, 15, importId);
        this.obs.detalheTab = ImportStore.obs.erros_import.length === 0 && ImportStore.obs.avisos_import.length > 0
          ? "avisos"
          : "erros"
        this.obs.detalhes_import = true
      } else {
        toast.warning('Sem dados para mostrar.', {});
      }
    };

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn disabled={!row._id} color="default" rounded size="sm" onClick={(e) => handleViewDetalhes(row)} >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    function statusFormatter(cell, row) {

      return getTag(row.status, "calculo");

    }

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };
    function stringFormatter(cell, row) {
      return (cell)?.toUpperCase();
    };

    function cnpjFormatter(cell, row) {
      if (row.cnpj) {
        let emp = EmpresaStore.getByCnpj(row.cnpj);
        if (emp) {
          return `${emp.razao_social.substring(0, 30)} - ${formatCnpj(row.cnpj)}`
        }
      }

      return ""
    };

    const renderErroItem = (obj, index) => {
      const podeBaixarXml = obj.mensagem.match(/Empresa não existe/gm) != null;
      return (
        <div className="detalheImportItem detalheImportItem--erro" key={index}>
          <Icon icon="error" className="detalheImportItemIcon" />
          <span className="detalheImportItemMsg">{obj.mensagem}</span>
          {podeBaixarXml &&
            <Tooltip position="top" content={"Download XML"} className="tooltipXml" openOnTargetFocus={false} usePortal={false}>
              <img src="/images/download.svg" width={18} style={{ cursor: "pointer" }} onClick={() => ImportStore.handleDownloadXml(obj.mensagem.match(/[0-9]{40,}/gm))} />
            </Tooltip>
          }
        </div>
      );
    };

    const renderAvisoItem = (obj, index) => {
      return (
        <div className="detalheImportItem detalheImportItem--aviso" key={index}>
          <Icon icon="warning-sign" className="detalheImportItemIcon" />
          <span className="detalheImportItemMsg">{obj.mensagem}</span>
        </div>
      );
    };

    let errosTextValidate = ImportStore.obs.erros_import.length
    let errosText = ImportStore.obs.erros_import?.map(renderErroItem)

    let avisosTextValidate = ImportStore.obs.avisos_import.length
    let avisosText = ImportStore.obs.avisos_import?.map(renderAvisoItem)

    const fetchMoreAvisos = async () => {
      this.obs.avisos_page = this.obs.avisos_page + 1
      await ImportStore.busca_avisos(this.obs.avisos_page, 15, this.obs.import_id)
    };

    const fetchMoreErros = async () => {
      this.obs.erros_page = this.obs.erros_page + 1
      await ImportStore.busca_erros(this.obs.erros_page, 15, this.obs.import_id)
    };

    let empresaTextImport = ImportStore.obs.selectedEmpresaImport.razao_social != ""
      ? `${ImportStore.obs.selectedEmpresaImport.razao_social.substring(0, 38)}... (${formatCnpj(ImportStore.obs.selectedEmpresaImport.cnpj)})`
      : "Selecione uma empresa";

    function geradoFormatter(cell, row) {
      switch (row.automatico) {
        case true:
          return <span className="new-tag-nav-new">Automático</span>
        default:
          return <span className="new-tag-nav">Manual</span>
      }
    }

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa (opcional)"

    return (
      <>
        <MDBRow>
          <MDBCol md="12">
            <MDBBtn
              className="btnDefault btnImportarXmls"
              onClick={(e) => ImportStore.obs.importarXmls = true}
              style={{ float: "left" }}
              data-tut="importar_xmls"
            >
              Importar XMLs
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <br />

        <MDBRow>
          <MDBCol md="3">

            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.handleBuscaImportacao(this.obs.selectEmpresa = e)}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  alignText={Alignment.LEFT}
                  rightIcon={
                    this.obs.selectEmpresa.cnpj ? (
                      <Icon
                        className="clear-icon-empresa"
                        icon="cross"
                        onClick={(ev) => {
                          ev.stopPropagation();
                          this.handleBuscaImportacao(this.obs.selectEmpresa = newEmpresa());
                        }}
                      />
                    ) : (
                      <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                    )
                  }
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup
              className="inputsPeriodoCalculos"
              label="Período"
            >
              <DateRangePicker
                onChange={this.handleDateSolicitacaoChange}
                value={this.obs.selectedPeriod}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Status">
              <HTMLSelect
                onChange={(e) => this.handleBuscaImportacao(this.obs.status = parseInt(e.target.value))}
                value={this.obs.status}
              >
                <option value={5}>Selecione</option>
                <option value={2}>Concluído</option>
                <option value={3}>Concluído com Erros</option>
                <option value={1}>Processando</option>
                <option value={0}>Novo</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={(e) => this.handleCleanFilter()} style={{ marginTop: 28 }}>
              Limpar Filtro
            </MDBBtn>
          </MDBCol>

          <MDBCol className="btns-Drop">
              <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => this.handleBuscaTarefasPaged(1)} style={{marginRight: 10, marginTop: 10}}>
                  Atualizar
              </MDBBtn>
          </MDBCol>
        </MDBRow>

        <BootstrapTable className="TableDefaultImport" data={ImportStore.obs.tarefas} style={{ marginTop: 10 }}>
          <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
          <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data</TableHeaderColumn>
          <TableHeaderColumn dataFormat={cnpjFormatter} width="30%">Empresa</TableHeaderColumn>
          <TableHeaderColumn dataField="descricao" width="35%">Descrição</TableHeaderColumn>
          <TableHeaderColumn dataFormat={stringFormatter} dataField="tipo" width="10%">Tipo</TableHeaderColumn>
          <TableHeaderColumn dataFormat={stringFormatter} dataField="modelo" width="10%">Modelo</TableHeaderColumn>
          <TableHeaderColumn dataFormat={stringFormatter} dataField="estado" width="10%">Estado</TableHeaderColumn>
          <TableHeaderColumn dataFormat={geradoFormatter} width="10%">Origem</TableHeaderColumn>
          <TableHeaderColumn dataFormat={statusFormatter} width="25%">Status</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Detalhes</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <PagerResultados
            currentPage={this.obs.tarefas_page}
            totalCount={ImportStore.obs.tarefas.length}
            pageSize={15}
            onPageChange={page => this.handleBuscaTarefasPaged(page)}
          />
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={ImportStore.obs.importarXmls}
          onClose={() => this.onCloseImportarXmls()}
          canOutsideClickCancel={true}
          className="ImportAlert"
        >
          <h2 className="titleSEFAZ">Importações</h2>
          <MDBRow style={{ marginBottom: -25 }}>
            <MDBCol md="6">
              <FormGroup className="empresaSelectImport" label="Empresa">
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => ImportStore.obs.selectedEmpresaImport = e}
                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                >
                  <Button
                    text={empresaTextImport}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                  />
                </EmpresaSelect>
              </FormGroup>
            </MDBCol>

            <MDBCol md="6">
              <FormGroup
                label="Descrição (Opcional)"
                labelFor="descricao"
              >
                <InputGroup id="descricao" onChange={(e: any) => ImportStore.obs.descricao_import = e.target.value} />
              </FormGroup>
            </MDBCol>

            <MDBCol md="12">
              <RadioGroup onChange={(e: any) => ImportStore.obs.rewritexml = e.target.value} selectedValue={ImportStore.obs.rewritexml} inline={true}>
                <Radio label="Sobrescrever registros existentes" value="1" />
                <Radio label="Importar somente registros inexistentes" value="0" />
              </RadioGroup>

            </MDBCol>

          </MDBRow>

          {ImportStore.obs.selectedEmpresaImport.razao_social == "" ?
            <div>
              <NonIdealState
                icon="box"
                title="Selecione a empresa para a qual deseja realizar a importação."
              />
            </div>
            :
            <Tabs
              id="tabs"
              className={"tabsCalculos"}
              selectedTabId={this.obs.selectedTab}
              onChange={(tabId) => this.obs.selectedTab = String(tabId)}
            >
              <Tab
                id="nfes"
                title="Importar NF-e"
                panel={<ImportNFESPage />} />

              <Tab
                id="nfce"
                title="Importar NFC-e"
                panel={<ImportNFCEPage />} />

              <Tab
                id="cte"
                title="Importar CT-e"
                panel={<ImportCTEPage />} />

              <Tab
                id="nfse"
                title="Importar NFS-e Ambiente Nacional"
                panel={<ImportNFSEPage />} />
            </Tabs>
          }

        </Alert>

        <Dialog
          isOpen={this.obs.detalhes_import}
          title="Detalhes da Importação"
          onClose={() => this.handleCloseDetalhes()}
          className="detalhesImportDialog"
        >
          <div className={Classes.DIALOG_BODY}>
            <div className="detalheImportResumo">
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum">{ImportStore.obs.import_summary.import.total}</span>
                <span className="detalheImportResumoLabel">Arquivos Processados</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className="detalheImportResumoNum detalheImportResumoNum--ok">{ImportStore.obs.import_summary.import.importados}</span>
                <span className="detalheImportResumoLabel">Arquivo(s) Calculado(s)</span>
              </div>
              <div className="detalheImportResumoItem">
                <span className={ImportStore.obs.import_summary.import.erros >= 1
                  ? "detalheImportResumoNum detalheImportResumoNum--erro"
                  : "detalheImportResumoNum"}>{ImportStore.obs.import_summary.import.erros}</span>
                <span className="detalheImportResumoLabel">Arquivo(s) com Erro(s)</span>
              </div>
            </div>

            {(!errosTextValidate && !avisosTextValidate) ?
              <div className="detalheImportSucesso">
                <img src="/images/pass_calculo.png" width={44} />
                <h3>Importação concluída com sucesso</h3>
                <p>Nenhum erro ou aviso foi encontrado nos arquivos importados.</p>
              </div>
              :
              <>
                <div className="detalheImportSeg">
                  {errosTextValidate ?
                    <button
                      type="button"
                      className={this.obs.detalheTab === "erros" ? "detalheImportSegBtn is-active" : "detalheImportSegBtn"}
                      onClick={() => this.obs.detalheTab = "erros"}
                    >
                      Erros
                      <span className="detalheImportSegCount detalheImportSegCount--erro">{errosTextValidate}</span>
                    </button> : null
                  }
                  {avisosTextValidate ?
                    <button
                      type="button"
                      className={this.obs.detalheTab === "avisos" ? "detalheImportSegBtn is-active" : "detalheImportSegBtn"}
                      onClick={() => this.obs.detalheTab = "avisos"}
                    >
                      Avisos
                      <span className="detalheImportSegCount detalheImportSegCount--aviso">{avisosTextValidate}</span>
                    </button> : null
                  }
                </div>

                <div className="detalheImportLista">
                  {this.obs.detalheTab === "avisos" && avisosTextValidate ?
                    <InfiniteScroll
                      dataLength={avisosText.length}
                      next={fetchMoreAvisos}
                      hasMore={true}
                      height={Math.min(300, Math.max(avisosText.length, 1) * 50)}
                      loader={""}
                    >
                      {avisosText}
                    </InfiniteScroll>
                    :
                    <InfiniteScroll
                      dataLength={errosText.length}
                      next={fetchMoreErros}
                      hasMore={true}
                      height={Math.min(300, Math.max(errosText.length, 1) * 45)}
                      loader={""}
                    >
                      {errosText}
                    </InfiniteScroll>
                  }
                </div>
              </>
            }
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.handleCloseDetalhes()} />
            </div>
          </div>
        </Dialog>

        <LoadingModal open={ImportStore.obs.loadingImport} onClose={() => ImportStore.obs.loadingImport = false} title={"Importando"} />
        <LoadingModal open={ImportStore.obs.loadingDownloadXml} onClose={() => ImportStore.obs.loadingDownloadXml = false} title={"Fazendo download do XML"} />

      </>
    )
  }
}

